import React from "react";

import { box, Box } from "../../../../../helpers/common/Box/Box";
import { Avatar } from "../../../../Avatar";
import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { AvatarProps } from "../../../../Avatar";
import type { AvatarSize } from "../../../../Avatar/Avatar/types";

const CONTENT_AVATAR_TEST_ID = createTestIdForContentElement("avatar");

type ConstantAvatar = "size";

export const ContentAvatar = box<
    BoxComponentWithDefault<typeof Avatar, unknown, ConstantAvatar>
>(({ as = Avatar, ...props }) => {
    const boxProps = props as unknown as AvatarProps<AvatarSize>;
    return <Box as={as} {...boxProps} data-tsid={CONTENT_AVATAR_TEST_ID} />;
});

ContentAvatar.displayName = createDisplayNameForContentElement("Avatar");

export default ContentAvatar;
